import React from 'react';
import { Link } from '@jelly/ui';
var QT_LINKS = {
  Paychex: 'https://businesscom.go2cloud.org/aff_c?offer_id=762&aff_id=1000&source=human-resources&aff_sub4=revenue%7CSponsorship&aff_sub3=deal%7CPaychex&url_id=314',
  'Rapid Finance': 'https://businesscom.go2cloud.org/aff_c?offer_id=244&aff_id=1000&source=finance&aff_sub4=revenue%7CSponsorship&aff_sub3=deal%7CRapid%Finance&url_id=1'
};

/**
 * This is the SponsoredLink that creates a QT link for the sponsored company
 *
 * @param {Node} props.children :: Contents that will be wrapped by the SponsoredLink
 * @param {String} props.sponsorLink :: QT link for the sponsored company
 * @param {String} props.sponsorName :: Name of the sponsored company
 */
export function SponsoredLink(_ref) {
  var children = _ref.children,
      sponsorLink = _ref.sponsorLink,
      _ref$sponsorName = _ref.sponsorName,
      sponsorName = _ref$sponsorName === void 0 ? '' : _ref$sponsorName;

  if (['Paychex', 'Rapid Finance'].includes(sponsorName)) {
    return /*#__PURE__*/React.createElement(Link, {
      href: sponsorLink || QT_LINKS[sponsorName]
    }, children);
  } // If you are not a sponsor in the list, you do not get a link


  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
}